import { useIntl } from "react-intl";
import { Link, useParams } from "react-router-dom";
import { useEffect, useState, useRef } from "react";
import { useLoading } from "../../components/LoadingContext";
import axios from "../../api/axiosClient";
import { handleError, errorToast } from "../../services/serviceBase";
import { Buffer } from "buffer";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import OpenWithIcon from "@mui/icons-material/OpenWith";
import AttachmentIcon from "@mui/icons-material/Attachment";
import CustomInput from "../../components/ui/CustomInput";
import BarcodeIcon from "../../components/ui/BarcodeIcon";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import TextSnippetIcon from "@mui/icons-material/TextSnippet";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import ModeEditIcon from "@mui/icons-material/ModeEdit";
import WarningIcon from "@mui/icons-material/Warning";
import QCDataHeader from "../../components/ui/QC/QCDataHeader";
import CropOriginalIcon from "@mui/icons-material/CropOriginal";
import { useSelector, useDispatch } from "react-redux";
import { setSelectedIdOutcome, setIdQualityCheck, setIsEdit, setBoxBarcode, setSelectedQty, setEmptyQC, setBackFromDefect } from "../../redux/qcSlice";
import store from "../../redux/store";
import DibaEditModal from "../../components/Modals/DibaEditModal";

const QCItem = () => {
  const intl = useIntl();
  const navigate = useNavigate();
  const { setLoading } = useLoading();
  const dispatch = useDispatch();

  const params = useParams();
  const { idReturnFileHead, idArticle, boxBarcode } = params;
  const selectedIdOutcome = useSelector((state) => state.qc.selectedIdOutcome);
  const currentIdQualityCheck = useSelector((state) => state.qc.idQualityCheck);
  const reduxIsEdit = useSelector((state) => state.qc.isEdit);
  const isEditFromUrl = boxBarcode !== null && boxBarcode !== undefined && boxBarcode !== "";
  const isEdit = reduxIsEdit || isEditFromUrl;
  const reduxBoxBarcode = useSelector((state) => state.qc.boxBarcode);
  const reduxQuantity = useSelector((state) => state.qc.selectedQty);
  const isBackFromDefect = useSelector((state) => state.qc.backFromDefect);

  const [returnFileByArticle, setReturnFileByArticle] = useState("");
  const [qcInfo, setQcInfo] = useState(null);
  const [sketch, setSketch] = useState("");
  const [qcAlreadyCreated, setQCAlreadyCreated] = useState(null);

  const [defects, setDefects] = useState([]);
  const [currentDefectDetail, setCurrentDefectDetail] = useState(null);
  const [renderAttach, setRenderAttach] = useState([]);
  const [saved, setSaved] = useState(false);  

  const [outcomes, setOutcomes] = useState([]);
  const [defaultBox, setDefaultBox] = useState(null);
  const [startUdm, setStartUdm] = useState(null);
  const [selectedOutcome, setSelectedOutcome] = useState(null);
  const [selectedBox, setSelectedBox] = useState(reduxBoxBarcode ?? '');
  const [selectedExtraQuantityBox, setSelectedExtraQuantityBox] = useState('');
  const [maxQuantity, setMaxQuantity] = useState(0);
  const [quantity, setQuantity] = useState(reduxQuantity !== null ? reduxQuantity : 1);
  const [firstQtyChanged, setFirstQtyChanged] = useState(false);
  const [focusedInput, setFocusedInput] = useState(null);
  const focusedRef = useRef(focusedInput);
  const [isOutcomeEnabledWithDefect, setIsOutcomeEnabledWithDefect] = useState(true);
  const [currentOutcome, setCurrentOutcome] = useState(null);

  const [expanded, setExpanded] = useState(false);
  const [showEQBox, setShowEQBox] = useState(false);

  const [qtyDivHeigth, setQtyDivHeigth] = useState(600);
  const [defectsDivHeigth, setDefectsDivHeigth] = useState(600);

  const [selectedButton, setSelectedButton] = useState(null);

  const [openCardsModal, setOpenCardsModal] = useState(false);
  const handleCloseCardsModal = () => {
    setOpenCardsModal(false);
    partialBarcode = "";
  };

  const handleOpenCardsModal = (e) => {
    e.preventDefault();
    setOpenCardsModal(true);
  };

  const [isToBeRepaired, setIsToBeRepaired] = useState(false);
  const [hasDiba, setHasDiba] = useState(false);

  const resizeTable = () => {
    var pageHeight = window.innerHeight;

    if (!expanded) {
      var qtyDivHeigth = document.querySelector("#QtyDiv")?.clientHeight;
      setQtyDivHeigth(qtyDivHeigth);
      var defectsDivHeigth = (pageHeight / 100) * 20;
      setDefectsDivHeigth(defectsDivHeigth);
    } else {
      var defectsDivHeigth = (pageHeight / 100) * 58;
      setDefectsDivHeigth(defectsDivHeigth);
    }
  };

  function handleEmptyQc(e) {
    if (
      !e.destination.url.includes("QCDefect") &&
      !e.destination.url.includes("QCItem")
    ) {
      store.dispatch(setEmptyQC());
    }
  };

  useEffect(() => {
    const handleResize = () => resizeTable();
    const handleNavigation = (e) => handleEmptyQc(e);
    
    window.addEventListener("resize", handleResize);
    if (window.navigation) {
      window.navigation.addEventListener("navigate", handleNavigation);
    }
    
    return () => {
      window.removeEventListener("resize", handleResize);
      if (window.navigation) {
        window.navigation.removeEventListener("navigate", handleNavigation);
      }
    };
  }, []);

  useEffect(() => {
    resizeTable();
    GetReturnFileByArticle();
  }, []);

  useEffect(() => {
    if (
      returnFileByArticle.articleInfo != "" &&
      returnFileByArticle.articleInfo != null &&
      returnFileByArticle.articleInfo != undefined
    ) {
      if (
        (qcInfo == "" || qcInfo == null || qcInfo == undefined) &&
        !isEdit &&
        currentIdQualityCheck == null
      ) {
        dispatch(
          setSelectedIdOutcome({
            selectedIdOutcome: null,
          }),
          setIsEdit({
            isEdit: false,
          }),
          setIdQualityCheck({
            idQualityCheck: null,
          })
        );
        QCCreate();
      } else if (currentIdQualityCheck != null && !isEdit) {
        getQualityCheck(currentIdQualityCheck);
      }
    }
  }, [returnFileByArticle]);
    
  useEffect(() => {
    focusedRef.current = focusedInput;
  }, [focusedInput]);

  const getPageData = async () => {
    setLoading(true);

    try {
      var idQc = getCurrentQCId();
      if (idQc === 0) {
        throw new Error('Quality Check ID not found');
      }

      const calls = [
        axios.get("/qualitycheck/" + idQc + "/defects"),
        axios.get("qualitycheck/Outcomes/" + idReturnFileHead)
      ];

      try {
        if(returnFileByArticle?.articleInfo?.barcode == undefined){
          return;
        }
        const sketchResponse = await axios.get("/qualitycheck/Sketches/" + returnFileByArticle?.articleInfo?.barcode, { responseType: "arraybuffer" });
        if (sketchResponse.data) {
          var base64 = Buffer.from(sketchResponse.data).toString("base64");
          setSketch(base64);
        }
      } catch (sketchError) {
        console.warn('Failed to load sketch:', sketchError);
        // Continue without sketch
      }

      const [defectsResponse, outcomesResponse] = await Promise.all(calls);
      
      //Defects
      if (defectsResponse?.data) {
        setDefects(defectsResponse.data);
      }

      //Outcomes
      if (outcomesResponse?.data && Array.isArray(outcomesResponse.data)) {
        let qualityCheckOutcomes = outcomesResponse.data;
        var sortedOutcomes = qualityCheckOutcomes.sort(function (a, b) {
          var x = a["sequence"] || 0;
          var y = b["sequence"] || 0;
          return x < y ? -1 : x > y ? 1 : 0;
        });
        setOutcomes(sortedOutcomes);
      }
    } catch (error) {
      handleError(error, intl);
    }
    finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    if (qcInfo != null || qcAlreadyCreated != null) {
      getPageData();
    }
  }, [qcInfo, qcAlreadyCreated]);

  useEffect(() => {
    if (isEditFromUrl && !reduxIsEdit) {
      dispatch(
        setIsEdit({
          isEdit: true,
        })
      );
    }
  }, [isEditFromUrl, reduxIsEdit]);

  useEffect(() => {
    if (isEdit) {
      if (boxBarcode != "" && boxBarcode !== null && boxBarcode !== undefined) {
        GetAlreadyCreatedQC();
        setSelectedBox(boxBarcode);
        dispatch(
          setBoxBarcode({
            boxBarcode: boxBarcode,
          })
        );
      }
    }
  }, [boxBarcode]);

  const QCCreate = () => {
    setLoading(true);
    let config = {
      headers: { "Content-Type": "application/json" },
    };
    axios
      .post(
        "returnfiles/" + idReturnFileHead + "/qualitycheck",
        JSON.stringify(returnFileByArticle.articleInfo.barcode),
        config
      )
      .then((response) => {
        setLoading(false);
        if (
          response != null &&
          response != undefined &&
          response.data !== null &&
          response.data !== undefined
        ) {
          if (response.data.isExtraQty) {
            toast(intl.formatMessage({ id: "QC.ExtraQuantityWarning" }), {
              icon: <WarningIcon size="large" />,
            });
          }
          setQcInfo(response.data);
          dispatch(
            setIdQualityCheck({
              idQualityCheck: response.data.idQualityCheck,
            })
          );
          setIsToBeRepaired(response.data.isToBeRepaired)
          setHasDiba(response.data.hasDiba)
        }
      })
      .catch((error) => {
        setLoading(false);
        navigate(`${process.env.PUBLIC_URL}/QCDetail/${idReturnFileHead}`)
        handleError(error, intl);
      });
  };

  const GetDefects = () => {
    setLoading(true);
    var idQc = getCurrentQCId();

    axios
      .get("/qualitycheck/" + idQc + "/defects")
      .then((response) => {
        setLoading(false);
        setDefects(response.data);
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const GetReturnFileByArticle = () => {
    setLoading(true);
    var url = "returnfiles/" + idReturnFileHead + "/" + idArticle;
    if (boxBarcode !== null && boxBarcode !== undefined) {
      const params = new URLSearchParams([]);
      params.append("boxBarcode", boxBarcode);
      url += "?" + params.toString();
    }

    axios
      .get(url)
      .then((response) => {
        setLoading(false);
        if (
          response != null &&
          response != undefined &&
          response.data !== null &&
          response.data !== undefined
        ) {
          setReturnFileByArticle(response.data);
          setMaxQuantity(response.data.quantity);
          if (boxBarcode !== null && boxBarcode !== undefined) {
            setQuantity(response.data.quantity);
            dispatch(
              setSelectedQty({
                selectedQty: response.data.quantity,
              })
            );
          }
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
        if (error?.response?.data?.type === "ReturnFileNotReceivedAtWarehouse") {
          navigate(-1);
        }
      });
  };

  const GetAlreadyCreatedQC = () => {
    setLoading(true);
    axios
      .get("/qualitycheck/boxes/" + boxBarcode + "/" + idArticle)
      .then((response) => {
        setLoading(false);
        if (
          response != null &&
          response != undefined &&
          response.data !== null &&
          response.data !== undefined
        ) {
          setQCAlreadyCreated(response.data);
          getQualityCheck(response.data[0].idQualityCheck);
          dispatch(
            setIdQualityCheck({
              idQualityCheck: response.data[0].idQualityCheck,
            })
          );
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  const handleDeleteDefect = () => {
    var idDefect = currentDefectDetail.idDefect;
    var idQc = getCurrentQCId();

    setLoading(true);
    axios
      .delete("/qualitycheck/" + idQc + "/" + currentOutcome + "/defects/" + idDefect)
      .then((response) => {
        setLoading(false);
        GetDefects();
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const handleEditDefect = () => {
    var idDefect = currentDefectDetail.idDefect;
    var idQc = getCurrentQCId();
    navigate("/QCDefect/" + idReturnFileHead + "/" + idArticle + "/" + idQc + "/" + idDefect);
  };

  useEffect(() => {
    resizeTable();
  }, [expanded]);

  const getStartUDM = (idQualityCheck, idAnagQCOutcome, callback) => {
    if(idAnagQCOutcome == undefined){
      return;
    }
    setLoading(true);
    axios
      .get("/qualitycheck/"+ idQualityCheck +"/boxprefixes/"+ idAnagQCOutcome)
      .then((response) => {
        setLoading(false);
        if (response != null && response != undefined && response.data !== null && response.data !== undefined ) {
          setStartUdm(response.data);
          callback(response.data);
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, () => {
          errorToast(error, intl);
        });
      });
  }

  const handleOutcomeClicked = (e, idAnagQCOutcome) => {
    e.preventDefault();

    setSelectedOutcome(idAnagQCOutcome);
    dispatch(
      setSelectedIdOutcome({
        selectedIdOutcome: idAnagQCOutcome,
      })
    );
    var lastUsedBox = qcInfo?.lastUsedBox?.find(
      (x) =>
        x.idQCOutcomeForRT === idAnagQCOutcome &&
        x.isExtraQty == qcInfo.isExtraQty
    );
    getStartUDM(currentIdQualityCheck, idAnagQCOutcome, (startUdm) => {
      if (lastUsedBox !== null && lastUsedBox !== undefined) {
        setDefaultBox(lastUsedBox);
      } else {
        setDefaultBox(null);
      }
    });
  };

  const handleSetQtyBtn = (e, code) => {
    e.preventDefault();

    try {
      if (code === "all") {
        const newQty = Math.max(0, maxQuantity || 0);
        setQuantity(newQty);
        dispatch(setSelectedQty({ selectedQty: newQty }));
      } else if (code === "c") {
        setQuantity(0);
        dispatch(setSelectedQty({ selectedQty: 0 }));
      } else {
        const currentQty = quantity || 0;
        const newQtyStr = !firstQtyChanged ? code.toString() : currentQty.toString() + code;
        const newQty = parseInt(newQtyStr);
        
        if (!isNaN(newQty) && newQty >= 0) {
          setQuantity(newQty);
          dispatch(setSelectedQty({ selectedQty: newQty }));
          if (!firstQtyChanged) {
            setFirstQtyChanged(true);
          }
        }
      }
    } catch (error) {
      console.error('Error in handleSetQtyBtn:', error);
      toast.error('Invalid quantity operation');
    }

    e.target.blur();
  };

  //#region Outcome Buttons

  useEffect(() => {
    let currentOutcome = null;
    if (outcomes.length != 0) {
      if (qcInfo?.idAnagQCOutcome != null && isEdit) {
        setSelectedButton(qcInfo?.idAnagQCOutcome);
        currentOutcome = qcInfo?.idAnagQCOutcome;
      } else if (selectedIdOutcome != null) {
        setSelectedButton(selectedIdOutcome);
        currentOutcome = selectedIdOutcome;
      } else {
        var defaultOutcome = outcomes.find(
          (x) => x.isDefaultOutcome
        ).idAnagQCOutcome;
        setSelectedButton(defaultOutcome);
        currentOutcome = defaultOutcome;
      }
    }

    getStartUDM(currentIdQualityCheck, currentOutcome, null);
    setCurrentOutcome(currentOutcome);

    if (qcInfo !== null && currentOutcome !== null) {
      var lastUsedBox = qcInfo.lastUsedBox?.find(
        (box) =>
          box.idQCOutcomeForRT === currentOutcome &&
          box.isExtraQty == qcInfo.isExtraQty
      );
      if (lastUsedBox !== null && lastUsedBox !== undefined) {
        setDefaultBox(lastUsedBox);
      }
    }
  }, [outcomes, qcInfo, selectedIdOutcome]);

  //#endregion

  useEffect(() => {
    dispatch(
      setBoxBarcode({
        boxBarcode: selectedBox,
      })
    );
  }, [selectedBox, selectedOutcome, selectedExtraQuantityBox]);

  const handleOpenNewDefect = () => {
    navigate(`${process.env.PUBLIC_URL}/QCDefect/${idReturnFileHead}/${idArticle}/${qcInfo.idQualityCheck}`);
  };

  const handleCancel = () => {
    store.dispatch(setEmptyQC());
  };

  //#region Dialog MissingPhoto
  const [openMissingPhotoDialog, setOpenMissingPhotoDialog] = useState(false);

  const handleClickOpenMissingPhotoDialog = () => {
    setOpenMissingPhotoDialog(true);
  };

  const handleCloseMissingPhotoDialog = (e, imageType) => {
    e.preventDefault();
    if (imageType == "NoImage" || imageType == "Sketch") {
      var url = "/missingPhoto/" + idArticle;
      const params = new URLSearchParams([]);
      params.append("imageType", imageType);
      url += "?" + params.toString();
      setLoading(true);

      axios
        .post(url)
        .then((response) => {
          setLoading(false);
          toast.success("Saved!");
          setOpenMissingPhotoDialog(false);
        })
        .catch((error) => {
          setLoading(false);
          handleError(error, intl, () => {
            errorToast(error, intl);
            setOpenMissingPhotoDialog(false);
          });
        });
    } else {
      setOpenMissingPhotoDialog(false);
    }
  };
  //#endregion

  const getDefectDetail = (idDefect) => {
    setLoading(true);

    var idQc = getCurrentQCId();

    axios
      .get("qualitycheck/" + idQc + "/defects/" + idDefect)
      .then((response) => {
        if (
          response != null &&
          response != undefined &&
          response.data !== null &&
          response.data !== undefined
        ) {
          var defectDetail = {
            idDefect: idDefect,
            Details: response.data,
          };

          setCurrentDefectDetail(defectDetail);

          const promises = defectDetail.Details.hashList.map((x) =>
            getExistingDefectThumbnail(currentDefectDetail?.idDefect, x)
          );
          Promise.all(promises).then((images) => {
            setLoading(false);
            setRenderAttach(images);
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        handleError(error, intl);
      });
  };

  const getExistingDefectThumbnail = async (idDefect, hash) => {
    try {
      var idQc = getCurrentQCId();
      if (idQc === 0 || !idDefect || !hash) {
        return { attachment: null, hash: hash };
      }
      
      const response = await axios.get(`/qualitycheck/${idQc}/defects/${idDefect}/thumbnails/${hash}`, {
        responseType: "arraybuffer",
      });
      
      if (response.data) {
        var base64 = Buffer.from(response.data).toString("base64");
        return { attachment: base64, hash: hash };
      }
      return { attachment: null, hash: hash };
    } catch (error) {
      console.warn(`Failed to load thumbnail for hash ${hash}:`, error);
      return { attachment: null, hash: hash };
    }
  };

  const handleOpenDefectDetails = (e, idDefect) => {
    e.preventDefault();
    setRenderAttach([]);
    getDefectDetail(idDefect);
  };

  const handleCloseDefectDetails = (e) => {
    e.preventDefault();
    setRenderAttach([]);
    setCurrentDefectDetail(null);
  };

  const handleSaveQC = (e) => {
    if (
      selectedBox == null ||
      selectedBox.length == 0 ||
      selectedBox.length != 18
    ) {
      toast.error(intl.formatMessage({ id: "Error.InsertBoxBarcode" }));
      return;
    } else {
      var idQc = getCurrentQCId();
      var url = "/qualitycheck/" + idQc;

      var data = {
        idQCOutcome: selectedButton,
        boxBarcode: selectedBox,
        extraQtyBoxBarcode: selectedExtraQuantityBox,
        quantity: quantity,
      };

      setLoading(true);
      axios
        .put(url, data)
        .then((response) => {
          setLoading(false);
          if(response.data.notFoundQtyForExtra > 0) {
            if(response.data.notFoundQtyForExtra == quantity){
              toast(intl.formatMessage({ id: "Error.ExtraArticleAllQtyWithoutInvoice" }), {
                icon: <WarningIcon size="large" />,
              });
            }
            else if(response.data.notFoundQtyForExtra < quantity){
              var message = intl
                .formatMessage({ id: "Error.ExtraArticlePartialQtyWithoutInvoice" })
                .replace("{0}", response.data.notFoundQtyForExtra );
              toast.error(message);
            }
          }

          if(response.data.idQualityChecks.length > 0) {
            dispatch(setEmptyQC({}));
            setSaved(true);
          }
          else{
            navigate(`${process.env.PUBLIC_URL}/QCDetail/${idReturnFileHead}`);
          }
        })
        .catch((error) => {
          setLoading(false);
          if (error?.response?.data?.type == "ExtraQtyForbidden") {
            setQuantity(1);
            toast.error(intl.formatMessage({ id: "Error.ExtraQtyForbidden" }));
          }
          else if (error?.response?.data?.type == "ExtraQtyError") {
            setShowEQBox(true);
            var pageHeight = window.innerHeight;
            var defectsDivHeigth = (pageHeight / 100) * 15;
            setDefectsDivHeigth(defectsDivHeigth);
            toast(intl.formatMessage({ id: "Error.ExtraQtyError" }), {
              icon: <WarningIcon size="large" />,
            });
          } else if (error?.response?.data?.type == "BoxAlreadyUsed") {
            var message = intl
              .formatMessage({ id: "Error.BoxAlreadyUsed" })
              .replace("{0}", showEQBox ? selectedExtraQuantityBox : selectedBox );
            toast.error(message);
          } else if (error?.response?.data?.type == "DefectsRequired") {
            handleOpenNewDefect();
          } else if (error?.response?.data?.type == "BarcodeNumericalFormat") {
            toast.error(intl.formatMessage({ id: "Error.BarcodeNumericalFormat" }));
          } else {
            handleError(error, intl);
            navigate(`${process.env.PUBLIC_URL}/QCDetail/${idReturnFileHead}`);
          }
        });
    }
  };

  const getQualityCheck = (idQualityCheck) => {
    setLoading(true);
    axios
      .get("/qualitycheck/" + idQualityCheck)
      .then((response) => {
        setLoading(false);
        setQcInfo(response.data);
        setIsToBeRepaired(response.data.isToBeRepaired)
        setHasDiba(response.data.hasDiba)
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  const getCurrentQCId = () => {
    var idQc = 0;
    if (qcInfo != null && qcInfo.idQualityCheck != null) {
      idQc = qcInfo.idQualityCheck;
    }
    if (qcAlreadyCreated != null && qcAlreadyCreated.length > 0 && qcAlreadyCreated[0].idQualityCheck != null) {
      idQc = qcAlreadyCreated[0].idQualityCheck;
    }
    return idQc;
  };

  useEffect(() => {
    if (saved) {
      navigate(`${process.env.PUBLIC_URL}/QCDetail/${idReturnFileHead}`);
    }
  }, [saved]);

  //#region Fire Box Barcode
  useEffect(() => {
    const handleBarcode = (e) => fireBarcodeListener(e);
    window.addEventListener("keyup", handleBarcode);
    return () => window.removeEventListener("keyup", handleBarcode);
  }, []);

  var partialBarcode = "";
  const [firedBarcode, setFiredBarcode] = useState("");

  const fireBarcodeListener = async (e) => {
    if (
      e.target.tagName === "INPUT" ||
      e.target.tagName === "TEXTAREA" ||
      e.target.isContentEditable
    ) {
      return;
    }

    const isNumber = /^[0-9]$/i.test(e.key);
    if (!isNumber) {
      return;
    }
    partialBarcode += e.key;
    if (partialBarcode.length == 18) {
      setFiredBarcode(partialBarcode);
      partialBarcode = "";
    }
  };

  useEffect(() => {
    if (firedBarcode !== "" && firedBarcode.length == 18) {
      if (showEQBox) {
        setSelectedExtraQuantityBox(firedBarcode);
      } else {
        setSelectedBox(firedBarcode);
      }
    }
  }, [firedBarcode]);

  useEffect(() => {
    if (
      ((selectedBox !== '' && selectedBox.length == 18) ||
        (selectedExtraQuantityBox !== null &&
          selectedExtraQuantityBox.length == 18)) &&
      !isEdit &&
      !isBackFromDefect
    ) {
      handleSaveQC();
    }
  }, [selectedBox, selectedExtraQuantityBox]);
  //#endregion

  const handleOpenEditAttachments = (e, hash) => {
    var idDefect = currentDefectDetail.idDefect;
    navigate(
      `/QCDefectAttachments/${idReturnFileHead}/${idArticle}/${idDefect}/${hash}`
    );
  };

  const handleQtyChange = (e) => {
    setQuantity(e);
    dispatch(
      setSelectedQty({
        selectedQty: e,
      })
    );
  };

  return (
    <div>
      <Box id="QCheader">
        <QCDataHeader
          article={returnFileByArticle?.articleInfo}
          head={returnFileByArticle?.returnFileHeadInfo}
          quantity={returnFileByArticle?.quantity}
        />
      </Box>
      <Grid container spacing={1} mt={0.2} id="mainContent" sx={{height: "70vh"}}>
        <Grid item xs={12} sm={12} md={4.5} lg={3.5} id="articleAndPhoto" sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <div id="articleInfos" style={{ border: "3px solid #EEEFF1", flexShrink: 0 }}>
            <Grid container ml={1}>
              <Grid item xs={1.8} sm={1.5} md={2.5} lg={1.8}>
                <Typography className="apeDarkGreyColor">
                  {intl.formatMessage({ id: "Article.Model" })}
                </Typography>
              </Grid>
              <Grid item xs={2} sm={2} md={2} lg={2}>
                <Typography>
                  {returnFileByArticle?.articleInfo?.styleCode}
                </Typography>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={1.8} sm={1.5} md={2.5} lg={1.8}>
                <Typography className="apeDarkGreyColor">
                  {intl.formatMessage({ id: "Article.Part" })}
                </Typography>
              </Grid>
              <Grid item xs={2} sm={2} md={2} lg={2}>
                <Typography>
                  {returnFileByArticle?.articleInfo?.fabricCode}
                </Typography>
              </Grid>
            </Grid>
            <Grid container ml={1}>
              <Grid item xs={1.8} sm={1.5} md={2.5} lg={1.8}>
                <Typography className="apeDarkGreyColor">
                  {intl.formatMessage({ id: "Article.Color" })}
                </Typography>
              </Grid>
              <Grid item xs={2} sm={2} md={2} lg={2}>
                <Typography>
                  {returnFileByArticle?.articleInfo?.colorCode}
                </Typography>
              </Grid>
              <Grid item xs={1}></Grid>
              <Grid item xs={1.8} sm={1.5} md={2.5} lg={1.8}>
                <Typography className="apeDarkGreyColor">
                  {intl.formatMessage({ id: "Article.Size" })}
                </Typography>
              </Grid>
              <Grid item xs={2} sm={2} md={2} lg={2}>
                <Typography>
                  {returnFileByArticle?.articleInfo?.size}
                </Typography>
              </Grid>
            </Grid>
            <Grid container ml={1}>
              <Grid item xs={12}>
                <Typography>
                  {returnFileByArticle?.articleInfo?.articleDescription}
                </Typography>
              </Grid>
            </Grid>
          </div>
          {sketch && sketch !== "" ? (
            <img
              id="qcDefectImage"
              src={`data:;base64,${sketch}`}
              alt="sketch"
              style={{ flex: 1, minHeight: 0, width: '100%', objectFit: 'contain' }}
            />
          ) : (
            <img
              id="qcDefectImage"
              src={process.env.PUBLIC_URL + "/img/no_image.png"}
              alt="Logo"
              style={{ flex: 1, minHeight: 0, width: '100%', objectFit: 'contain' }}
            />
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={7.5} lg={8.5} id="qcActions" sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          <Grid container alignItems="center" mb={1} sx={{ flexShrink: 0 }}>
            <Grid item lg={6}>
              <Grid container>
                <Grid item lg={2}>
                  <Typography className="apeLigthBlueColor" fontSize={20}>
                    {intl.formatMessage({ id: "QC.Defects" })}
                  </Typography>
                </Grid>
                {currentDefectDetail !== null && (
                  <Grid item lg={1}>
                    <IconButton onClick={handleDeleteDefect} disabled={isEdit}>
                      <DeleteForeverIcon fontSize="small" />
                    </IconButton>
                  </Grid>
                )}
                {currentDefectDetail !== null && (
                  <Grid item lg={1}>
                    <IconButton onClick={handleEditDefect} disabled={isEdit}>
                      <ModeEditIcon fontSize="small" />
                    </IconButton>
                  </Grid>
                )}
                <Grid item lg={1}>
                  <IconButton onClick={handleExpand}>
                    <OpenWithIcon fontSize="small" />
                  </IconButton>
                </Grid>
              </Grid>
            </Grid>
            <Grid item lg={isToBeRepaired ? 4 : 5}></Grid>
            {/* <Grid item lg={1}>
              <Button
                variant="outlined"
                className={"QcBlueButton"}
                onClick={(e) => handleSaveQC(e)}
                fullWidth
              >
                {intl.formatMessage({ id: "TechInfo" })}
              </Button>
            </Grid> */}
            <Grid item lg={1}>
              {hasDiba ? 
              (<Button
                variant="outlined"
                className={"QcBlueButton"}
                onClick={(e) => {
                  handleOpenCardsModal(e);
                }}
                fullWidth
              >
                {intl.formatMessage({ id: "Diba.Title" })}
              </Button>) : ("" )
              }
            </Grid>
            {isToBeRepaired ? (
                <Grid item lg={1} sx={{ ml: "auto", textAlign: "right" }}>
                    <img
                        width="65px"
                        src={require("../../img/ToBeRepairedIcon.jpg")}
                    />
                </Grid>
            ) : (
                ""
            )}
          </Grid>

          <div
            style={{
              textAlign: "center",
              backgroundColor: "#99B1CC",
              display: "flex",
            }}
          >
            <Typography
              sx={{ mr: "auto", color: "white", mt: 0.4, ml: 0.2 }}
              fontSize={20}
            >
              {intl.formatMessage({ id: "QC.Defect" })}
            </Typography>
            <IconButton
              sx={{ ml: "auto" }}
              component="label"
              disableRipple={true}
            >
              <AttachmentIcon
                fontSize="small"
                sx={{ color: "white", transform: "rotate(-45deg)" }}
              />
            </IconButton>
          </div>
          <div style={{ textAlign: "center", height: `${defectsDivHeigth}px` }}>
            <Grid sx={{ maxHeight: "100%", overflow: "auto" }}>
              {defects && defects.length > 0
                ? defects.map((x, i) => {
                    var defectDetail = null;
                    if (
                      currentDefectDetail != null &&
                      currentDefectDetail?.idDefect == x.idQCDefect
                    ) {
                      defectDetail = currentDefectDetail;
                    }
                    return (
                      <div key={x.idQCDefect || i}>
                        {defectDetail == null ? (
                          <Grid
                            container
                            key={x.qcDefectName}
                            onClick={(e) =>
                              handleOpenDefectDetails(e, x.idQCDefect)
                            }
                          >
                            <Grid item xs={0.5} textAlign="center">
                              <Typography>{i + 1}</Typography>
                            </Grid>
                            <Grid item xs={8} textAlign="left">
                              <Typography>{x.qcDefectName}</Typography>
                            </Grid>
                            <Grid item xs={x?.hasAttachments ? 2.3 : 3}></Grid>
                            <Grid item xs={0.5} textAlign="end">
                              <IconButton
                                sx={{ ml: "auto" }}
                                component="label"
                                disableRipple={true}
                              >
                                <TextSnippetIcon fontSize="small" />
                              </IconButton>
                            </Grid>
                            {x?.hasAttachments ? (
                              <Grid item xs={0.5} textAlign="end">
                                <IconButton
                                  sx={{ ml: "auto" }}
                                  component="label"
                                  disableRipple={true}
                                >
                                  <CropOriginalIcon fontSize="small" />
                                </IconButton>
                              </Grid>
                            ) : (
                              <Grid item xs={0.5}></Grid>
                            )}
                          </Grid>
                        ) : (
                          <Box
                            sx={{ backgroundColor: "#DAE5F2" }}
                            onClick={(e) =>
                              handleCloseDefectDetails(e, x.idQCDefect)
                            }
                          >
                            <Grid container>
                              <Grid item xs={0.5}>
                                <Typography>{i + 1}</Typography>
                              </Grid>
                              <Grid item xs={8}>
                                <Grid container>
                                  {defectDetail?.Details?.attributesList?.map?.(
                                    (x, i) => {
                                      return (
                                        <Grid
                                          item
                                          xs={12}
                                          textAlign={"left"}
                                          key={i}
                                        >
                                          <Typography>
                                            {x.label} : {x.attributeName}
                                          </Typography>
                                        </Grid>
                                      );
                                    },
                                  )}
                                  <Grid item xs={12} textAlign={"left"}>
                                    <Typography>
                                      {defectDetail?.Details?.note || ""}
                                    </Typography>
                                  </Grid>
                                </Grid>
                              </Grid>
                              <Grid
                                item
                                xs={x?.hasAttachments ? 2.3 : 3}
                              ></Grid>
                              <Grid item xs={0.5} textAlign="end">
                                <IconButton
                                  sx={{ ml: "auto" }}
                                  component="label"
                                  disableRipple={true}
                                >
                                  <TextSnippetIcon fontSize="small" />
                                </IconButton>
                              </Grid>
                              {x?.hasAttachments ? (
                                <Grid item xs={0.5} textAlign="end">
                                  <IconButton
                                    sx={{ ml: "auto" }}
                                    component="label"
                                    disableRipple={true}
                                  >
                                    <CropOriginalIcon fontSize="small" />
                                  </IconButton>
                                </Grid>
                              ) : (
                                <Grid item xs={0.5}></Grid>
                              )}
                            </Grid>
                            <Grid container spacing={1} mt={1}>
                              {renderAttach && renderAttach.length > 0
                                ? renderAttach.map((x, i) => {
                                    return (
                                      <Grid item ml={1} key={x.hash || i}>
                                        <img
                                          src={
                                            x.attachment
                                              ? `data:;base64,${x.attachment}`
                                              : ""
                                          }
                                          width={100}
                                          height={100}
                                          key={x.hash || i}
                                          onClick={(e) =>
                                            handleOpenEditAttachments(e, x.hash)
                                          }
                                          onError={(e) => {
                                            e.target.style.display = "none";
                                          }}
                                        />
                                      </Grid>
                                    );
                                  })
                                : null}
                            </Grid>
                          </Box>
                        )}
                      </div>
                    );
                  })
                : ""}
            </Grid>
          </div>
          {!expanded ? (
            <Grid container spacing={0.2}>
              <Grid item xs={12} sm={5} md={4} lg={4}>
                <div
                  style={{ textAlign: "center", backgroundColor: "#99B1CC" }}
                >
                  <Typography sx={{ color: "white" }} fontSize={20}>
                    {intl.formatMessage({ id: "General.Quantity" })}
                  </Typography>
                </div>
                <div
                  style={{ textAlign: "center", backgroundColor: "#DAE5F2" }}
                  id="QtyDiv"
                >
                  <Grid container>
                    <Grid item xs={1.2} sm={1.2} md={1.2} lg={1.2}></Grid>
                    <Grid item xs={10.8} sm={10.8} md={10.8} lg={10.8}>
                      <CustomInput
                        labelText={`${intl.formatMessage({
                          id: "General.Quantity",
                        })}:`}
                        type="number"
                        classInput="apeBlueColor"
                        value={quantity}
                        setValue={handleQtyChange}
                        textCol={3}
                        inputCol={7.5}
                      />
                    </Grid>
                  </Grid>
                  <Grid container>
                    <Grid item xs={0.1} lg={1.2}></Grid>
                    <Grid item xs={3.9} lg={3.2} mt={1}>
                      <Button
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                        onClick={(e) => handleSetQtyBtn(e, 1)}
                      >
                        1
                      </Button>
                    </Grid>
                    <Grid item xs={4} lg={3.2} mt={1}>
                      <Button
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                        onClick={(e) => handleSetQtyBtn(e, 2)}
                      >
                        2
                      </Button>
                    </Grid>
                    <Grid item xs={3.9} lg={3.2} mt={1}>
                      <Button
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                        onClick={(e) => handleSetQtyBtn(e, 3)}
                      >
                        3
                      </Button>
                    </Grid>
                    <Grid item xs={0.1} lg={1.2}></Grid>
                    <Grid item xs={0.1} lg={1.2}></Grid>
                    <Grid item xs={3.9} lg={3.2} mt={1}>
                      <Button
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                        onClick={(e) => handleSetQtyBtn(e, 4)}
                      >
                        4
                      </Button>
                    </Grid>
                    <Grid item xs={4} lg={3.2} mt={1}>
                      <Button
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                        onClick={(e) => handleSetQtyBtn(e, 5)}
                      >
                        5
                      </Button>
                    </Grid>
                    <Grid item xs={3.9} lg={3.2} mt={1}>
                      <Button
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                        onClick={(e) => handleSetQtyBtn(e, 6)}
                      >
                        6
                      </Button>
                    </Grid>
                    <Grid item xs={0.1} lg={1.2}></Grid>
                    <Grid item xs={0.1} lg={1.2}></Grid>
                    <Grid item xs={3.9} lg={3.2} mt={1}>
                      <Button
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                        onClick={(e) => handleSetQtyBtn(e, 7)}
                      >
                        7
                      </Button>
                    </Grid>
                    <Grid item xs={4} lg={3.2} mt={1}>
                      <Button
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                        onClick={(e) => handleSetQtyBtn(e, 8)}
                      >
                        8
                      </Button>
                    </Grid>
                    <Grid item xs={3.9} lg={3.2} mt={1}>
                      <Button
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                        onClick={(e) => handleSetQtyBtn(e, 9)}
                      >
                        9
                      </Button>
                    </Grid>
                    <Grid item xs={0.1} lg={1.2}></Grid>
                    <Grid item xs={0.1} lg={1.2}></Grid>
                    <Grid item xs={3.9} lg={3.2} mt={1}>
                      <Button
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                        onClick={(e) => handleSetQtyBtn(e, "all")}
                      >
                        {intl.formatMessage({ id: "General.All" })}
                      </Button>
                    </Grid>
                    <Grid item xs={4} lg={3.2} mt={1}>
                      <Button
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                        onClick={(e) => handleSetQtyBtn(e, 0)}
                      >
                        0
                      </Button>
                    </Grid>
                    <Grid item xs={3.9} lg={3.2} mt={1}>
                      <Button
                        variant="outlined"
                        sx={{ backgroundColor: "white" }}
                        onClick={(e) => handleSetQtyBtn(e, "c")}
                      >
                        C
                      </Button>
                    </Grid>
                    <Grid item xs={0.1} lg={1.2}></Grid>
                  </Grid>
                  <Grid sx={{ height: 10 }}> </Grid>
                </div>
              </Grid>
              <Grid item xs={12} sm={7} md={8} lg={8}>
                <div
                  style={{ textAlign: "center", backgroundColor: "#99B1CC" }}
                >
                  <Typography sx={{ color: "white" }} fontSize={20}>
                    {intl.formatMessage({ id: "QC.Outcome" })}
                  </Typography>
                </div>
                <div
                  style={{
                    textAlign: "center",
                    backgroundColor: "#DAE5F2",
                    height: `${qtyDivHeigth}px`,
                  }}
                >
                  <Grid
                    container
                    sx={{ maxHeight: `${qtyDivHeigth}px`, overflow: "auto" }}
                  >
                    {outcomes && outcomes.length > 0
                      ? outcomes.map((x) => (
                          <Grid
                            item
                            lg={6}
                            mt={1}
                            key={x.idAnagQCOutcome || Math.random()}
                          >
                            <Button
                              variant="outlined"
                              sx={{
                                backgroundColor: "white",
                                width: "70%",
                              }}
                              className={
                                selectedButton === x.idAnagQCOutcome
                                  ? "QcBlueButton"
                                  : ""
                              }
                              onClick={(e) => {
                                setSelectedButton(x.idAnagQCOutcome);
                                handleOutcomeClicked(e, x.idAnagQCOutcome);
                                setIsOutcomeEnabledWithDefect(
                                  x.enabledWithDefect,
                                );
                              }}
                              disabled={isEdit}
                            >
                              {x.buttonLabel}
                            </Button>
                          </Grid>
                        ))
                      : ""}
                  </Grid>
                </div>
              </Grid>
            </Grid>
          ) : (
            ""
          )}
          {!expanded ? (
            <Grid container sx={{ backgroundColor: "#99B1CC", mt: "1px" }}>
              <Grid item xs={5.5} sm={4} md={4} lg={3}>
                {defaultBox !== null && defaultBox !== undefined ? (
                  <Button
                    className="QcBlueButton"
                    variant="outlined"
                    sx={{ ml: 1, mt: 1, mb: 1 }}
                    onClick={(e) => {
                      setSelectedBox(defaultBox.boxBarcode);
                    }}
                    disabled={isEdit}
                  >
                    {defaultBox.boxBarcode}
                  </Button>
                ) : (
                  ""
                )}
              </Grid>
              <Grid item xs={0} sm={1} md={1} lg={2.5}></Grid>
              <Grid item xs={1} sm={1} md={1} lg={1.5}>
                <Typography sx={{ color: "white", mt: 1 }}>
                  {intl.formatMessage({ id: "QC.StartUDM" })}: {startUdm}
                </Typography>
              </Grid>
              <Grid item xs={5.5} sm={6} md={6} lg={5}>
                <CustomInput
                  labelText={intl.formatMessage({ id: "QC.NewBox" })}
                  type="text"
                  classInput="apeBlueColor greyBackground"
                  value={selectedBox}
                  setValue={(e) => {
                    setSelectedBox(e);
                  }}
                  setFocused={(e) => {
                    setFocusedInput(e);
                  }}
                  iconComponent={BarcodeIcon}
                  textCol={3.5}
                  inputCol={8.5}
                  id="newBox"
                />
              </Grid>
            </Grid>
          ) : (
            ""
          )}
          {!expanded && showEQBox ? (
            <Grid container sx={{ backgroundColor: "#99B1CC", mt: "1px" }}>
              <Grid item xs={0} sm={6} md={6} lg={4}></Grid>
              <Grid item xs={12} sm={6} md={6} lg={8}>
                <CustomInput
                  labelText={intl.formatMessage({
                    id: "QC.NewExtraQuantityBox",
                  })}
                  type="text"
                  classInput="apeBlueColor greyBackground"
                  value={selectedExtraQuantityBox}
                  setValue={(e) => {
                    setSelectedExtraQuantityBox(e);
                  }}
                  iconComponent={BarcodeIcon}
                  textCol={5}
                  inputCol={7}
                  id="newBoxExtra"
                />
              </Grid>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
      </Grid>
      <Grid container mt={1} spacing={1} id="QCButtons">
        <Grid item xs={6} sm={2} md={1} lg={1}>
          <Link to={`/QCDetail/${idReturnFileHead}`}>
            <Button
              variant="outlined"
              className="apeBlueColor"
              fullWidth
              onClick={handleCancel}
            >
              {intl.formatMessage({ id: "General.Cancel" })}
            </Button>
          </Link>
        </Grid>
        <Grid item xs={6} sm={3} md={2} lg={1.8}>
          <Button
            variant="outlined"
            className="apeBlueColor"
            fullWidth
            onClick={handleClickOpenMissingPhotoDialog}
          >
            {intl.formatMessage({ id: "QC.MissingPhoto" })}
          </Button>
        </Grid>
        <Grid item xs={0} sm={0.5} md={4.4} lg={4.9}></Grid>
        <Grid item xs={6} sm={3} md={1.8} lg={1.8}>
          <Button
            variant="outlined"
            className={isOutcomeEnabledWithDefect ? "" : "QcDisabledButton"}
            disabled={!isOutcomeEnabledWithDefect || isEdit}
            fullWidth
            onClick={(e) => {
              handleOpenNewDefect();
            }}
          >
            {intl.formatMessage({ id: "QC.NewDefect" })}
          </Button>
        </Grid>
        <Grid item xs={6} sm={2} md={1.8} lg={1.5}>
          <Button
            variant="outlined"
            className="apeBlueColor"
            onClick={handleExpand}
            endIcon={
              expanded ? <KeyboardArrowDownIcon /> : <KeyboardArrowUpIcon />
            }
            fullWidth
          >
            {intl.formatMessage({ id: "QC.Outcome" })}
          </Button>
        </Grid>
        <Grid item xs={6} sm={1} md={1} lg={1}>
          <Button
            variant="outlined"
            className={"QcBlueButton"}
            fullWidth
            onClick={(e) => handleSaveQC(e)}
          >
            {intl.formatMessage({ id: "QC.Save" })}
          </Button>
        </Grid>
      </Grid>

      <Dialog
        open={openMissingPhotoDialog}
        onClose={handleCloseMissingPhotoDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {intl.formatMessage({ id: "General.Warning" })}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {intl.formatMessage({ id: "QC.MissingPhotoMessage" })}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => handleCloseMissingPhotoDialog(e, "Sketch")}>
            {intl.formatMessage({ id: "QC.MissingPhotoSketch" })}
          </Button>
          <Button
            onClick={(e) => handleCloseMissingPhotoDialog(e, "NoImage")}
            autoFocus
          >
            {intl.formatMessage({ id: "QC.MissingPhotoNoImage" })}
          </Button>
        </DialogActions>
      </Dialog>

      <DibaEditModal
        openModal={openCardsModal}
        handleCloseModal={handleCloseCardsModal}
        idQualityCheck={currentIdQualityCheck}
        article={
          returnFileByArticle?.articleInfo != null
            ? returnFileByArticle?.articleInfo
            : []
        }
        disableSaving={isEdit}
      />
    </div>
  );
};

export default QCItem;
